export const parseApolloError = error => {
  if (!error) return {}
  try {
    return JSON.parse(error.message);
  } catch {
    return {"__all__": [error.message]}
  }
}